import {
  createValidation,
  validatorMaxLength,
  validatorRequired,
} from '../../utils/formValidators';
import { countries } from '../../constants/parameters';

export default createValidation([
  {
    name: countries.CODE,
    validators: [validatorRequired(), validatorMaxLength(3)],
  },
  {
    name: countries.ESTONIAN,
    validators: validatorRequired(),
  },
  {
    name: countries.ENGLISH,
    validators: [validatorRequired()],
  },
]);
